<template>
  <v-form ref="form" class="layout wrap justify-space-between">
    <v-flex md6 xs12>
      <div class="mr-lg-4">
        <label>Название шаблона</label>
        <v-text-field
          v-model="fields.name"
          height="48"
          solo
          :rules="[rules.required]"
        >
        </v-text-field>

        <label>
          Адрес, на который отправится пользователь при переходе по рекламе на
          русском языке
        </label>
        <v-text-field
          v-model="fields.link.ru"
          height="48"
          solo
          :rules="[rules.url]"
        ></v-text-field>

        <label>
          Адрес, на который отправится пользователь при переходе по рекламе на
          английском языке
        </label>
        <v-text-field
          v-model="fields.link.en"
          height="48"
          solo
          :rules="[rules.url]"
        ></v-text-field>

        <label>Текст на русском языке</label>
        <v-text-field v-model="fields.text.ru" height="48" solo></v-text-field>

        <label>Текст на английском языке</label>
        <v-text-field v-model="fields.text.en" height="48" solo></v-text-field>
      </div>
    </v-flex>

    <v-flex md6 xs12>
      <v-layout>
        <v-flex lg8 xl7 class="adv-set--datepicker">
          <label>Период проведения</label>
          <date-range-picker
            :range="range"
            :index="5"
            :isShowError="true"
            @update="changeDate($event)"
          ></date-range-picker>
        </v-flex>
      </v-layout>

      <div class="font-weight-medium d-flex align-center">
        Кому показывать рекламу
        <hint-widget hintName="advertisingRange" type="tooltip">
          <template slot="activatorHint">
            <v-btn class="ma-0 mt-1" icon>
              <icon-help></icon-help>
            </v-btn>
          </template>
        </hint-widget>
      </div>
      <div class="checkBoxList pt-2">
        <v-checkbox
          @change="setChangeParam('clientsNew', fields.params.clients.new)"
          v-model="fields.params.clients.new"
          label="Новым клиентам"
          hide-details
          onIcon=""
          offIcon=""
          class="font-weight-medium mt-1"
        ></v-checkbox>

        <v-checkbox
          @change="setChangeParam('clientsAgain', fields.params.clients.again)"
          v-model="fields.params.clients.again"
          label="Клиентам, пришедшим повторно"
          hide-details
          onIcon=""
          offIcon=""
          class="font-weight-medium"
        ></v-checkbox>

        <v-checkbox
          @change="setChangeParam('clientsMany', fields.params.clients.many)"
          v-model="fields.params.clients.many"
          hide-details
          onIcon=""
          offIcon=""
          class="font-weight-medium clients-input-wrapper"
        >
          <template #label>
            <label>Клиентам, пришедшим более</label>
            <v-text-field
              class="clients-input"
              v-model="fields.params.clients.counts"
              mask="##"
              solo
              height="32"
            >
            </v-text-field>
            раз
          </template>
        </v-checkbox>
      </div>
      <div class="pt-3">
        <div class="font-weight-bold">
          Хот-споты, к которым применяется реклама
        </div>

        <div
          v-for="hotspot in params.hotspots"
          :key="hotspot.id"
          class="subtitle-1 text-no-wrap mt-3 mb-2 d-flex align-center"
        >
          <span class="valign-middle font-weight-bold flex-none">
            {{ hotspot.title }}
            <div class="text--secondary font-weight-medium text-capitalize">
              {{ hotspot.address }}
            </div>
          </span>
          <v-btn @click="deleteHotspot(hotspot.id)" icon class="flex-none my-0">
            <icon-close></icon-close>
          </v-btn>
        </div>

        <v-layout class="ma-0">
          <v-select
            :items="hotspotList"
            v-model="hotspotIdSelected"
            item-value="id"
            item-text="title"
            open-on-clear
            append-icon=""
            height="48"
            dense
            solo
          >
            <template #append>
              <icon-angle class="ma-0 link"></icon-angle>
            </template>
          </v-select>

          <v-btn
            @click="addHotspot"
            class="primary my-0"
            style="height: 48px"
            outline
            :disabled="!hotspotIdSelected"
          >
            Добавить
          </v-btn>
        </v-layout>
      </div>
    </v-flex>

    <v-flex lg3 xl3 md6>
      <div
        class="flex fill-height layout column ma-0 justify-space-between"
        :class="!isMobile ? 'block-load-img' : 'content-bg--4'"
      >
        <label class="d-block pt-3 px-2">
          Изображение для мобильных (320×270px) по-русски
        </label>
        <div
          class="align-center ma-0"
          :class="isLargeScreen ? 'd-block' : 'layout'"
        >
          <div
            class="flex xs7 sm6 md7 lg12 block-load-img--height"
            :class="{ 'text-xs-center': isLargeScreen }"
          >
            <img
              v-if="files.bgXSrus"
              :src="files.bgXSrus.path"
              class="img-fluid"
            />
          </div>
          <div
            class="flex"
            :class="{
              'layout wrap justify-start pt-0 mx-0 px-0': isLargeScreen,
              'justify-space-around': this.$vuetify.breakpoint.width > '1579',
            }"
          >
            <div
              v-if="files.bgXSrus"
              @click="
                $emit('openDialog', {
                  type: 'img',
                  fullwidth,
                  src: files.bgXSrus.path,
                })
              "
              class="d-flex subtitle-2 link align-end py-1 mr-2"
              flat
            >
              <icon-search
                width="17"
                height="16"
                viewBox="0 0 20 20"
                class="flex-none mr-2"
              ></icon-search>
              Увеличить
            </div>
            <div
              v-if="files.bgXSrus"
              @click="fileDelete('bgXSrus')"
              class="d-flex subtitle-2 link align-end py-1"
              flat
            >
              <icon-close
                width="16"
                height="16"
                viewBox="0 0 20 20"
                class="flex-none mr-2"
              ></icon-close>
              Удалить
            </div>
          </div>
        </div>
        <v-btn
          @click="$refs.bgXSrus.click()"
          class="primary preview-button flex-none"
          :class="{ 'flex py-1 ml-0': isLargeScreen }"
          outline
          :block="isLargeScreen"
        >
          Загрузить
        </v-btn>
        <input
          v-show="false"
          ref="bgXSrus"
          type="file"
          @change="changeImg('bgXSrus')"
        />
      </div>
    </v-flex>

    <v-flex lg3 xl3 md6>
      <div
        class="flex fill-height layout column ma-0 justify-space-between"
        :class="!isMobile ? 'block-load-img' : 'content-bg--4'"
      >
        <label class="d-block pt-3 px-2">
          Изображение для мобильных (320×270px) по-английски
        </label>
        <div
          class="align-center ma-0"
          :class="isLargeScreen ? 'd-block' : 'layout'"
        >
          <div
            class="flex xs7 sm6 md7 lg12 lg12 block-load-img--height"
            :class="{ 'text-xs-center': isLargeScreen }"
          >
            <img
              v-if="files.bgXSen"
              :src="files.bgXSen.path"
              class="img-fluid"
            />
          </div>
          <div
            class="flex"
            :class="{
              'layout wrap justify-start pt-0 mx-0 px-0': isLargeScreen,
              'justify-space-around': this.$vuetify.breakpoint.width > '1579',
            }"
          >
            <div
              v-if="files.bgXSen"
              @click="
                $emit('openDialog', {
                  type: 'img',
                  fullwidth,
                  src: files.bgXSen.path,
                })
              "
              class="d-flex subtitle-2 link align-end py-1 mr-2"
              flat
            >
              <icon-search
                width="17"
                height="16"
                viewBox="0 0 20 20"
                class="flex-none mr-2"
              ></icon-search>
              Увеличить
            </div>
            <div
              v-if="files.bgXSen"
              @click="fileDelete('bgXSen')"
              class="d-flex subtitle-2 link align-end py-1"
              flat
            >
              <icon-close
                width="16"
                height="16"
                viewBox="0 0 20 20"
                class="flex-none mr-2"
              ></icon-close>
              Удалить
            </div>
          </div>
        </div>
        <v-btn
          @click="$refs.bgXSen.click()"
          class="primary preview-button flex-none"
          :class="{ 'flex py-1': isLargeScreen }"
          outline
          :block="isLargeScreen"
        >
          Загрузить
        </v-btn>
        <input
          v-show="false"
          ref="bgXSen"
          type="file"
          @change="changeImg('bgXSen')"
        />
      </div>
    </v-flex>

    <v-flex lg3 xl3 md6>
      <div
        class="flex fill-height layout column ma-0 justify-space-between"
        :class="!isMobile ? 'block-load-img' : 'content-bg--4'"
      >
        <label class="d-block pt-3 px-2">
          Изображение для компьтеров (1920×600px) по-русски
        </label>
        <div
          class="align-center ma-0"
          :class="isLargeScreen ? 'd-block' : 'layout'"
        >
          <div
            class="flex xs7 sm6 md7 lg12 lg12 block-load-img--height"
            :class="{ 'text-xs-center': isLargeScreen }"
          >
            <img
              v-if="files.bgXLrus"
              :src="files.bgXLrus.path"
              class="img-fluid"
            />
          </div>
          <div
            class="flex"
            :class="{
              'layout wrap justify-start pt-0 mx-0 px-0': isLargeScreen,
              'justify-space-around': this.$vuetify.breakpoint.width > '1579',
            }"
          >
            <div
              v-if="files.bgXLrus"
              @click="
                $emit('openDialog', {
                  type: 'img',
                  fullwidth,
                  src: files.bgXLrus.path,
                })
              "
              class="d-flex subtitle-2 link align-end py-1 mr-2"
              flat
            >
              <icon-search
                width="17"
                height="16"
                viewBox="0 0 20 20"
                class="flex-none mr-2"
              ></icon-search>
              Увеличить
            </div>
            <div
              v-if="files.bgXLrus"
              @click="fileDelete('bgXLrus')"
              class="d-flex subtitle-2 link align-end py-1"
              flat
            >
              <icon-close
                width="16"
                height="16"
                viewBox="0 0 20 20"
                class="flex-none mr-2"
              ></icon-close>
              Удалить
            </div>
          </div>
        </div>
        <v-btn
          @click="$refs.bgXLrus.click()"
          class="primary preview-button flex-none"
          :class="{ 'flex py-1': isLargeScreen }"
          outline
          :block="isLargeScreen"
        >
          Загрузить
        </v-btn>
        <input
          v-show="false"
          ref="bgXLrus"
          type="file"
          @change="changeImg('bgXLrus')"
        />
      </div>
    </v-flex>

    <v-flex lg3 xl3 md6>
      <div
        class="flex fill-height layout column ma-0 justify-space-between"
        :class="!isMobile ? 'block-load-img' : 'content-bg--4'"
      >
        <label class="d-block pt-3 px-2">
          Изображение для компьтеров (1920×600px) по-английски
        </label>
        <div
          class="align-center ma-0"
          :class="isLargeScreen ? 'd-block' : 'layout'"
        >
          <div
            class="flex xs7 sm6 md7 lg12 lg12 block-load-img--height"
            :class="{ 'text-xs-center': isLargeScreen }"
          >
            <img
              v-if="files.bgXLen"
              :src="files.bgXLen.path"
              class="img-fluid"
            />
          </div>
          <div
            class="flex"
            :class="{
              'layout wrap justify-start pt-0 mx-0 px-0': isLargeScreen,
              'justify-space-around': this.$vuetify.breakpoint.width > '1579',
            }"
          >
            <div
              v-if="files.bgXLen"
              @click="
                $emit('openDialog', {
                  type: 'img',
                  fullwidth,
                  src: files.bgXLen.path,
                })
              "
              class="d-flex subtitle-2 link align-end py-1 mr-2"
              flat
            >
              <icon-search
                width="17"
                height="16"
                viewBox="0 0 20 20"
                class="flex-none mr-2"
              ></icon-search>
              Увеличить
            </div>
            <div
              v-if="files.bgXLen"
              @click="fileDelete('bgXLen')"
              class="d-flex subtitle-2 link align-end py-1"
              flat
            >
              <icon-close
                width="16"
                height="16"
                viewBox="0 0 20 20"
                class="flex-none mr-2"
              ></icon-close>
              Удалить
            </div>
          </div>
        </div>
        <v-btn
          @click="$refs.bgXLen.click()"
          class="primary preview-button flex-none"
          :class="{ 'flex py-1': isLargeScreen }"
          outline
          :block="isLargeScreen"
        >
          <span v-if="files.bgXLen">Загрузить другое</span>
          <span v-else>Загрузить</span>
        </v-btn>
        <input
          v-show="false"
          ref="bgXLen"
          type="file"
          @change="changeImg('bgXLen')"
        />
      </div>
    </v-flex>

    <v-flex xs12>
      <v-btn
        @click="save"
        class="primary"
        :class="{ 'tile btn-fixed': isMobile }"
        :block="isMobile"
      >
        Сохранить
      </v-btn>
    </v-flex>
  </v-form>
</template>

<script>
import IconAngle from "../icon/IconAngle.vue";
import IconClose from "../icon/IconClose.vue";
import IconSearch from "../icon/IconSearch.vue";
import IconHelp from "../icon/IconHelp.vue";
import requestApi from "../../modules/requestApi";
import config from "../../../config.js";
import HintWidget from "../common/HintWidget.vue";
import CyrillicToTranslit from "cyrillic-to-translit-js";
import DateRangePicker from "../common/DateRangePicker.vue";

export default {
  name: "AdvSettings",

  components: {
    IconAngle,
    IconClose,
    IconSearch,
    IconHelp,
    DateRangePicker,
    HintWidget,
  },

  props: {
    params: {
      type: Object,
    },
  },

  data: () => ({
    // выбранный хотспот для добавления
    hotspotIdSelected: null,
    rules: {
      required: (v) => !!v.trim() || "Поле обязательно для заполнения",
      url: (v) =>
        /^(https?:\/\/)?([\w.-]+)\.([\w-]{2,8}.?)(\/[\w-.]*)*\/?$/.test(v) ||
        "Введенная строка не является ссылкой",
    },
    range: { startDate: null, endDate: null },
    // метки изменения checkbox "Кому показывать рекламу"
    changeParams: {
      clientsNew: false,
      clientsAgain: false,
      clientsMany: false,
    },
  }),

  beforeMount() {
    if (this.fields.end && this.fields.start) {
      this.range.endDate = this.fields.end;
      this.range.startDate = this.fields.start;
    }
  },

  computed: {
    // список доступных хотспотов
    hotspotList() {
      let items;
      if (this.hotspots) {
        items = this.$store.getters.hotspotList.filter(
          (item) =>
            !this.hotspots.map((hotspot) => hotspot.id).includes(item.id)
        );
      } else {
        items = [...this.$store.getters.hotspotList];
      }
      return items;
    },
    fields() {
      let params = { ...this.params };
      return params;
    },
    files() {
      return this.params.params.files;
    },
    isMobile() {
      return ["xs"].includes(this.$vuetify.breakpoint.name);
    },
    isLargeScreen() {
      return ["lg"].includes(this.$vuetify.breakpoint.name);
    },
  },

  methods: {
    setDefaultChangeParams() {
      // обнуляем метки измененных параметров
      this.changeParams = {
        clientsNew: false,
        clientsAgain: false,
        clientsMany: false,
      };
    },
    save() {
      if (this.$refs.form.validate()) {
        this.fields.end = this.range.endDate;
        this.fields.start = this.range.startDate;
        this.$emit("save", this.fields, this.changeParams);
        this.setDefaultChangeParams();
      }
    },
    /** Смена файла картинки при загрузке нового */
    changeImg(ref) {
      const oldFile = this.files[ref];
      if (this.$refs[ref].files[0]) {
        if (oldFile) {
          requestApi
            .deleteFile({ file: this.files[ref].path })
            .then(() => this.fileUpload(ref));
        } else {
          this.fileUpload(ref);
        }
      }
    },
    /** Загрузка файла картинки */
    fileUpload(ref) {
      this.files[ref] = this.$refs[ref].files[0];

      if (this.files[ref].size / 1024 / 1024 > 2) {
        this.$store.dispatch("popupInfoOpen", {
          text: "Размер превышает 2 Мб",
          timeout: 5000,
        });
        this.files[ref] = null;
      } else {
        const cyrillicToTranslit = new CyrillicToTranslit();
        // переводит названия загруженного файла из кириллицы в транслит
        let fileName = cyrillicToTranslit.transform(
          this.$refs[ref].files[0].name,
          "_"
        );
        // дополнительный объект blob с данными размера и расширения картинки
        let blob = this.files[ref].slice(
          0,
          this.files[ref].size,
          this.files[ref].type
        );
        // добавляем в новый File предыдущие значения + имя транслитом + тип содержимого нового Blob
        const newFile = new File([blob], fileName, {
          type: this.files[ref].type,
        });
        requestApi.uploadFile({ file: newFile }).then((response) => {
          this.files[ref] = response;
          this.files[ref].path = `${response.path}`;
          this.save();
        });
      }
    },
    /** Удаление файла картинки */
    fileDelete(ref) {
      if (this.params.id) {
        requestApi.deleteFile({ file: this.files[ref].path }).then(() => {
          this.files[ref] = "";
          this.save();
        });
      }
    },
    /**
     * Ставит метку при изменении checkbox
     * для метрики
     */
    setChangeParam(param, value) {
      this.changeParams[param] = value;
    },
    /**
     * Прикрепить рекламу к хотспоту
     */
    addHotspot() {
      if (this.$refs.form.validate()) {
        let params = {};
        this.fields.end = this.range.end;
        this.fields.start = this.range.start;
        params = {
          advertising: this.fields,
          changeParams: { ...this.changeParams },
        };
        params.hotspot_id = this.hotspotIdSelected;
        this.$emit("addHotspot", params);
        this.setDefaultChangeParams();
        this.hotspotIdSelected = null;
      }
    },
    /**
     * Открепить рекламу от хотспота
     */
    // открепление опроса от хотспота
    deleteHotspot(id_hotspot) {
      this.$emit("deleteHotspot", id_hotspot);
    },
    // обновляем дату
    changeDate(range) {
      this.range = range;
    },
  },
};
</script>
